import React from "react";
import PropTypes from "prop-types";
import { ButtonGroupStyle } from "./ButtonGroupStyle";
import labels from "../../../config/labels";
import { componentCheckSize } from "../../../utils/helperServices";
import config from "../../../config/index";

const ButtonGroupOrderHistory = (props) => {
    const isTablet = componentCheckSize() <= 992;
    const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
	return (
		<div>
			{ isTablet &&
				<div>
                    <div>
                        <button className="left-btn-md p-s" onClick={() => props.toggleComps('years')}>
                            <img className="button-image" src={`${imagePrefix}/assets/images/icon-4px-calendar.svg`} alt="years" />
                            <span className="button-label"> Years: </span>
                            <span className="button-text"> {props?.selectedYearVal} </span>
                            <img src={`${imagePrefix}/assets/images/caret-right.svg`} className="right-arrow float-right"/>
                        </button>
                    </div>
                    <div>
                        <button className="right-btn-md p-s" onClick={() => props.toggleComps('sort')}>
                            <img  className="button-image" src={`${imagePrefix}/assets/images/sort.svg`} alt="sort" />
                            <span className="button-label">{labels.lbl_sort_by}: </span> <span className="button-text"> {props?.selectedSortVal} </span>
                            <img src={`${imagePrefix}/assets/images/caret-right.svg`} className="right-arrow float-right"/>
                        </button>
                    </div>
				</div>
            }

			<style jsx>{ButtonGroupStyle}</style>
		</div>
	);
};

ButtonGroupOrderHistory.propTypes = {
	hide: PropTypes.bool,
    toggleComps: PropTypes.func,
    selectedYearVal: PropTypes.string,
    selectedSortVal: PropTypes.string
};
export default ButtonGroupOrderHistory;
